module.exports = __webpack_public_path__ + "img/Slide27.2b3c29d8.png";